
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-emerald-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="text-3xl font-bold mb-4 block">
              Jhigu
            </Link>
            <p className="text-emerald-100 mb-6">
              Made for us. Quality ladies clothing with style and comfort for every woman in Nepal.
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/my-orders" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  My Orders
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="#" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Shipping Info
                </a>
              </li>
              <li>
                <a href="#" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Returns & Exchanges
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line mt-1"></i>
                <span className="text-emerald-100">Ramgram, Parasi, Nepal</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line mt-1"></i>
                <span className="text-emerald-100">+977 98XXXXXXXX</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line mt-1"></i>
                <span className="text-emerald-100">info@jhigu.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line mt-1"></i>
                <span className="text-emerald-100">Mon-Sat: 9AM - 6PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-emerald-500/30">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-emerald-100 text-sm">
              © 2024 Jhigu. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-3">
                <i className="ri-shield-check-line text-emerald-200"></i>
                <span className="text-emerald-100 text-sm">Secure Payment</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-truck-line text-emerald-200"></i>
                <span className="text-emerald-100 text-sm">Fast Delivery</span>
              </div>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="text-emerald-100 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
